var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurtains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4v16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4v16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4v16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4v16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5c1.7 1.1 2.5 2.5 2.5 4S8.7 15.9 7 17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5c-1.7 1.1-2.5 2.5-2.5 4s.8 3.4 2.5 4.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 16.5l1.8 1.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 16.5L14 17.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtains);
export default __webpack_public_path__ + "static/media/curtains.7890e6656b01a53f9fe4dbd85dd8bf7f.svg";
export { ForwardRef as ReactComponent };